import { getCart } from '@/services/Cart/getCart'

export { getCart } from '@/services/Cart/getCart'

export default getCart
